<template>
  <div>
    <!-- <iframe
      scrolling="no"
      src="https://tianqiapi.com/api.php?style=ya&skin=pitaya"
      frameborder="0"
      width="220"
      height="300"
      allowtransparency="true"
    ></iframe> -->
    <iframe
      scrolling="no"
      src="https://tianqiapi.com/api.php?style=ti&skin=pitaya"
      frameborder="0"
      width="220"
      height="300"
      allowtransparency="true"
    ></iframe>
    <!-- <div id="weather-v2-plugin-standard" ref="weather" style="width:100%"></div>
    <remote-script
      src="https://apip.weatherdt.com/standard/static/js/weather-standard-common.js?v=2.0"
    ></remote-script> -->
  </div>
</template>
<script>
// window.WIDGET = { ID: "FGT4M5ccwE" }; // 将WIDGET前边加上window 否则读取不到此变量
window.WIDGET = {
  CONFIG: {
    layout: 2,
    width: 240,
    height: "260",
    background: 2,
    dataColor: "4A4A4A",
    language: "zh",
    borderRadius: 5,
    key: "FGT4M5ccwE"
  }
};
import Vue from "vue";
Vue.component("remote-script", {
  // vue动态生成script (在html中当成组件来用)
  render: function(createElement) {
    var self = this;
    return createElement("script", {
      attrs: {
        type: "text/javascript",
        src: this.src
      },
      on: {
        load: function(event) {
          self.$emit("load", event);
        },
        error: function(event) {
          self.$emit("error", event);
        },
        readystatechange: function(event) {
          if (this.readyState == "complete") {
            self.$emit("load", event);
          }
        }
      }
    });
  },
  props: {
    src: {
      type: String,
      required: true
    }
  }
});
export default {
  name: "Weather",
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
#weather-v2-plugin-standard {
  width: 100% !important;
}
</style>
